import { render, staticRenderFns } from "./AdvisorViews.vue?vue&type=template&id=67d5110e&scoped=true"
import script from "./AdvisorViews.vue?vue&type=script&lang=js"
export * from "./AdvisorViews.vue?vue&type=script&lang=js"
import style0 from "./AdvisorViews.vue?vue&type=style&index=0&id=67d5110e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d5110e",
  null
  
)

export default component.exports